import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after { 
   // reset browser default styles
   box-sizing: border-box;
   margin: 0;
   padding: 0;
  }

  /* custom scroll */
  ::-webkit-scrollbar {
    width: 0.25rem;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.neutralBackgroundMedium};
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutralBorderMedium};
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.neutralBorderStrong};
  }

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* An outline, never a box-shadow: a global shadow would replace the shadows of cards and menus on focus. */
  :focus-visible {
    outline-width: 2px;
    outline-style: solid;
    outline-color: ${({ theme }) => theme.focusRing};
    outline-offset: 0;
  }

  body {
    margin: 0;
    color: ${({ theme }) => theme.neutralText};
    background-color: ${({ theme }) => theme.neutralBackgroundBase};
    font-optical-sizing: auto;
  }

  /* Bold (700) is loaded for the type scale table, but the browser's own bold elements stay SemiBold, as they rendered
     before the face existed. An element that wants Bold sets font-weight: 700 itself. */
  b,
  strong,
  th,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
  }

  /* The font family and the body text style come from core/BaseTypography. */
  button {
    font-optical-sizing: auto;
    font-size: inherit;
  }

  .mb-0 {
    margin-bottom: 0 !important;
  }

  .mb-8 {
    margin-bottom: 0.5rem !important;
  }

  .mb-16 {
    margin-bottom: 1rem !important;
  }

  .mb-24 {
    margin-bottom: 1.5rem !important;
  }

  .mb-32 {
    margin-bottom: 2rem !important;
  }
  
  .mb-40 {
    margin-bottom: 2.5rem !important;
  }

  .mb-80 {
    margin-bottom: 5rem;
  }

  .font-xs {
    font-size: 0.75rem !important;
    line-height: 1.6666666667 !important;
  }

  .font-sm {
    font-size: 0.875rem !important;
    line-height: 1.4285714286 !important;
  }

  .font-medium {
    font-weight: 500 !important;
  }

  .visually-hidden {
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    opacity: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
`;

export default GlobalStyle;
